import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Tenant {
  id: string;
  name: string;
}

interface TenantViewState {
  selectedTenant: Tenant | null;
  isViewingAsTenant: boolean;
  
  // Actions
  setSelectedTenant: (tenant: Tenant | null) => void;
  clearTenantView: () => void;
}

export const useTenantViewStore = create<TenantViewState>()(
  persist(
    (set) => ({
      selectedTenant: null,
      isViewingAsTenant: false,

      setSelectedTenant: (tenant) =>
        set({
          selectedTenant: tenant,
          isViewingAsTenant: tenant !== null,
        }),

      clearTenantView: () =>
        set({
          selectedTenant: null,
          isViewingAsTenant: false,
        }),
    }),
    {
      name: 'tenant-view-storage',
    }
  )
);

